<template>
    <div class="nosotros body">
        <div class="banner" id="banner">
            <div class="content">
                <h1 v-if="lang == 'eng'">ABOUT US</h1>
                <h1 v-else-if="lang == 'esp'">ACERCA DE NOSOTROS</h1>
            </div>
        </div>
        <div class="content">
            <b-row>
                <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
                    <div class="text" v-if="lang == 'eng'">
                        <h4>WHO ARE WE?</h4>
                        <p>We are a proudly Tijuana company, focused on the Tijuana-San Diego region. We are dedicated to display brands, products and services on digital screens. We are a young company with great commitment and passion for our work. We know that the way to make ourselves known is through our clients; that is why we have a customer-focused service, thus making the customer and their experience the center of our strategy. That is why with Border Comercial, grows without borders.</p>
                    </div>
                    <div class="text" v-else-if="lang == 'esp'">
                        <h4>¿Quiénes somos?</h4>
                        <p>Somos una empresa orgullosamente Tijuanense, enfocada en la región Tijuana-San Diego. Nos dedicamos a la Exposición de marcas, productos y servicios en pantallas digitales. Somos una empresa joven pero con gran compromiso y pasión por nuestro trabajo. Sabemos que la manera de darnos a conocer es que veas a nuestros clientes; por eso tenemos un servicio enfocado al cliente, convirtiendo así al cliente y su experiencia en el centro de nuestra estrategia. Por eso con Border Comercial, Crece sin Fronteras.</p>
                    </div>

                    <div class="text" v-if="lang == 'eng'">
                        <h4>OUR MISSION</h4>
                        <p>Position brands, products and services in view of their target market, with the best exposure for the Tijuana-San Diego border market on digital screens with optimal operation and strategic placement.</p>
                    </div>
                    <div class="text" v-else-if="lang == 'esp'">
                        <h4>NUESTRA MISIÓN</h4>
                        <p>Colocar marcas, productos y servicios a la vista de su mercado meta, con la mejor exposición para el mercado fronterizo Tijuana-San Diego en pantallas digitales con óptimo funcionamiento y estratégicamente colocadas.</p>
                    </div>

                    <div class="text" v-if="lang == 'eng'">
                        <h4>OUR VISION</h4>
                        <p>Grow beyond borders, becoming a binational outdoor advertising company with a presence in both Californias.</p>
                    </div>
                    <div class="text" v-else-if="lang == 'esp'">
                        <h4>NUESTRA VISIÓN</h4>
                        <p>Crecer más allá de las fronteras, llegando a ser una empresa de publicidad exterior, binacional teniendo presencia en ambas californias.</p>
                    </div>
                </b-col>
            </b-row>
            <div class="valores">
                <h4 v-if="lang == 'eng'">OUR VALUES</h4>
                <h4 v-else-if="lang == 'esp'">NUESTROS VALORES</h4>
                <b-row>
                    <b-col cols="6" md="4" lg="2">
                        <div class="valor">
                            <img src="../assets/img/icn_v_innovacion.svg" alt="Innovacion">
                            <p v-if="lang == 'eng'">Innovation</p>
                            <p v-else-if="lang == 'esp'">Innovación</p>
                        </div>
                    </b-col>
                    <b-col cols="6" md="4" lg="2">
                        <div class="valor">
                            <img src="../assets/img/icn_v_calidad.svg" alt="Innovacion">
                            <p v-if="lang == 'eng'">Quality</p>
                            <p v-else-if="lang == 'esp'">Calidad</p>
                        </div>
                    </b-col>
                    <b-col cols="6" md="4" lg="2">
                        <div class="valor">
                            <img src="../assets/img/icn_v_eficiencia.svg" alt="Innovacion">
                            <p v-if="lang == 'eng'">Efficiency</p>
                            <p v-else-if="lang == 'esp'">Eficiencia</p>
                        </div>
                    </b-col>
                    <b-col cols="6" md="4" lg="2">
                        <div class="valor">
                            <img src="../assets/img/icn_v_pasion.svg" alt="Innovacion">
                            <p v-if="lang == 'eng'">Passion</p>
                            <p v-else-if="lang == 'esp'">Pasión</p>
                        </div>
                    </b-col>
                    <b-col cols="6" md="4" lg="2">
                        <div class="valor">
                            <img src="../assets/img/icn_v_honestidad.svg" alt="Innovacion">
                            <p v-if="lang == 'eng'">Honesty</p>
                            <p v-else-if="lang == 'esp'">Honestidad</p>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
        <img src="../assets/img/img_nosotrosbg2.jpg" alt="Nosotros">
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex'
    export default {
        computed:{
            ...mapState(['lang'])
        }
    }
</script>

<style scoped>
    .nosotros *{
        color: #383838;
    }
    .banner{
        background-image: url('../assets/img/img_nosotrosbg1.jpg');
        background-size: cover;
        background-position: center;
        padding: 140px 0;
    }
    h1{
        text-align: center;
        color: white!important;
        font-family: 'sailecBlack';
        margin: 0;
    }
    img{
        width: 100%;
    }
    .text{
        margin-top: 80px;
    }
    h4{
        font-family: 'sailecBlack';
        text-transform: uppercase;
    }
    .text p{
        line-height: 1.8;
        margin: 0;
    }
    .valores{
        padding: 100px 0;
        text-align: center;
    }
    .valor{
        background-color: #00B5C0;
        padding: 30px 20px;
    }
    .valores p{
        color: white;
        margin-top: 20px;
    }
    .valores img{
        width: 62%;
        margin: 0 auto;
    }
    .valores .row{
        justify-content: center;
    }
    .valores h4{
        margin-bottom: 50px;
    }

    @media screen and (max-width: 991px){
        .valor{
            margin: 15px 0;
        }
    }
    @media screen and (max-width: 767px){
        .banner{
            padding: 100px 0;
        }
        h1{
            font-size: 25pt;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Nosotros.vue